import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback handles session exchange first
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const loginEmail = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token); setUser(r.data.user); return r.data.user;
  };
  const registerEmail = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setToken(r.data.token); setUser(r.data.user); return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    clearToken(); setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh, loginEmail, registerEmail, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
